import { createFileRoute, notFound } from "@tanstack/react-router";
import { ApiError } from "@/api/client";
import { storeProductsQuery, storeQuery } from "@/api/queries/stores";
import type { CategorySlug } from "@/api/types";
import { StorePage } from "@/pages/store/StorePage";
import { StorePageSkeleton } from "@/pages/store/StorePageSkeleton";

const CATEGORIES: CategorySlug[] = [
  "3d",
  "ui",
  "systems",
  "plugins",
  "maps",
  "vfx",
  "vehicles",
  "scripts",
  "audio",
  "animations",
];
const SORTS = ["popular", "newest", "price-asc", "price-desc"] as const;

type StoreSearch = {
  category?: CategorySlug;
  sort: (typeof SORTS)[number];
};

export type { StoreSearch };

function validateSearch(search: Record<string, unknown>): StoreSearch {
  const category = typeof search.category === "string" && CATEGORIES.includes(search.category as CategorySlug)
    ? (search.category as CategorySlug)
    : undefined;
  const sort = typeof search.sort === "string" && SORTS.includes(search.sort as StoreSearch["sort"])
    ? (search.sort as StoreSearch["sort"])
    : "popular";
  return { category, sort };
}

export const Route = createFileRoute("/_app/store/$slug")({
  validateSearch,
  loader: async ({ context, params }) => {
    try {
      const store = await context.queryClient.ensureQueryData(storeQuery(params.slug));
      void context.queryClient.prefetchQuery(storeProductsQuery(params.slug, {}));
      return store;
    } catch (error) {
      if (error instanceof ApiError && error.status === 404) throw notFound();
      throw error;
    }
  },
  pendingComponent: StorePageSkeleton,
  component: StorePage,
});
